import EventEmitter from './utils/eventEmitter';

import './utils/objectFit';

import AccessToken from './interceptors/accessToken/accessToken';
import ErrorInterceptor from './interceptors/errorInterceptor/errorInterceptor';

import services from './services/services';
import filters from './filters/filters';
import directives from './directives/directives';

let commonModule = angular.module('common', [
  services,
  filters,
  directives,
  AccessToken,
  ErrorInterceptor
])

  .value('EventEmitter', EventEmitter)

  .name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js